import * as ChartActions from "./ChartActions";
import * as ViewActions from "./ViewActions";
import * as DataActions from "./DataActions";
import * as ToolTipActions from "store/actions/ToolTipActions";
import * as ErrorActions from "store/actions/ErrorActions";

export * from "./ChartActions";
export * from "./ViewActions";
export * from "./DataActions";
export * from "store/actions/ToolTipActions";
export * from "store/actions/ErrorActions";

export default {...ChartActions, ...ViewActions, ...DataActions, ...ToolTipActions, ...ErrorActions};



// WEBPACK FOOTER //
// ./src/kpi/store/actions/index.js